import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useProductStore } from '@elem/compPage/a-new-era-of-cool/ProductProvider';
import { IPageStatus } from '@elem/compPage/a-new-era-of-cool/config/IPageStatus';
import { needTermsCheckLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';
import HomeownersSection from '../HomeownersSection';
import { useRouter } from 'next/router';

export default function Comp() {
    const { t } = useLang('theProduct.HomeownersSection');
    const { locale } = useRouter();

    const { pageStatus } = useProductStore();

    return <HomeownersSection title={t('title_1')} />;
}
